// extracted by mini-css-extract-plugin
module.exports = {"logos":"Logos_logos__fhqS7","imageWrapper":"Logos_imageWrapper__zBFnQ","imageContainer":"Logos_imageContainer__lHW1o","image":"Logos_image___hsRV","scale":"Logos_scale__W7D19"};